import {
    _CustomizeProduct,
    type _CustomizeProductParams,
    type CustomDigitalGiftCardActionModel
} from 'autogen/swagger/all';
import CustomGiftCard from 'components/customizeProduct/customGiftCard';
import { addToCartTypeEventCategoryMapper, GA4Tracking } from 'modules/tracking/GA4';
import type { ProductActionProps } from '../../shared/types';

export async function openCustomGiftCardModal({ productId, listName }: _CustomizeProductParams) {
    try {
        // backend need to check the customizeProduct endpoint. it says it returns the base model which is why we are casting it to the correct model here
        const data = (await _CustomizeProduct({ productId, listName })) as CustomDigitalGiftCardActionModel;

        const { default: createModal } = await import(/* webpackChunkName: "modal" */ 'modules/modal');
        const modal = createModal();
        await modal({ open: true, content: <CustomGiftCard {...data} /> });
    } catch (error) {
        console.error(error);
    }
}

export default async function addCustomGiftCard({ params, trackingInfo }: ProductActionProps['CustomizeProduct']) {
    try {
        await openCustomGiftCardModal(params);

        const GA4TrackingObject = addToCartTypeEventCategoryMapper(trackingInfo.eventCategory);

        GA4TrackingObject.eventParams?.push({
            param_name: 'is_digital_product',
            param_value: true
        });

        GA4Tracking(GA4TrackingObject);
    } catch (error) {
        console.error(error);
    }
}
